import { bitDecode, bitEncode } from './bit-flag';

export class OverdriveTracking {
    public get analyticsTrackingEnabled() { return bitDecode(1, this.flags); }
    public set analyticsTrackingEnabled(enabled: boolean) { this.flags = bitEncode(enabled, 1, this.flags); }

    public get performanceTrackingEnabled() { return bitDecode(0, this.flags); }
    public set performanceTrackingEnabled(enabled: boolean) { this.flags = bitEncode(enabled, 0, this.flags); }

    public flags = '0';

    constructor(flags: string, isGdprCountry?: boolean) {
        if (flags) {
            this.flags = flags;
            return;
        }

        if (!isGdprCountry) {
            this.performanceTrackingEnabled = true;
            this.analyticsTrackingEnabled = true;
        } else {
            this.performanceTrackingEnabled = false;
            this.analyticsTrackingEnabled = false;
        }
    }
}
